// import React, { useState } from "react";
// import {
//   FaPhoneAlt,
//   FaMapMarkerAlt,
//   FaLinkedinIn,
//   FaInstagram,
//   FaFacebookF,
//   FaYoutube,
//   FaWhatsapp,
// } from "react-icons/fa";

// const ContactForm = () => {
//   const COLORS = {
//     bgPrimary: "#0B1C2D",
//     bgSecondary: "#13293D",
//     gold: "#C6A75E",
//     textLight: "#EAEAEA",
//   };

//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     subject: "",
//     message: "",
//   });

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({ ...formData, [name]: value });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     const { name, email, subject, message } = formData;

//     const whatsappMessage = `New Contact Form Submission:%0AName: ${name}%0AEmail: ${email}%0ASubject: ${subject}%0AMessage: ${message}`;
//     const adminNumber = "919625975135";

//     window.open(
//       `https://wa.me/${adminNumber}?text=${whatsappMessage}`,
//       "_blank",
//       "noopener noreferrer"
//     );

//     setFormData({ name: "", email: "", subject: "", message: "" });
//   };

//   return (
//     <section
//       style={{ backgroundColor: COLORS.bgPrimary }}
//       className="py-16 sm:py-20 md:py-24 px-4 sm:px-6 md:px-12 lg:px-20 relative"
//     >
//       <div className="max-w-7xl mx-auto">
        
//         {/* HEADER */}
//         <div className="mb-10 sm:mb-12 md:mb-16">
//           <div className="flex items-center gap-3 sm:gap-4 mb-3 sm:mb-4">
//             <div
//               className="h-[2px] w-10 sm:w-16"
//               style={{ backgroundColor: COLORS.gold }}
//             ></div>

//             <span
//               style={{ color: COLORS.gold }}
//               className="uppercase tracking-widest text-xs sm:text-sm font-bold"
//             >
//               Legal Support
//             </span>
//           </div>

//           <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-7xl text-white font-bold leading-tight">
//             Contact{" "}
//             <span className="text-white/40 font-light">
//               Shailendra Kumar Singh.
//             </span>
//           </h2>
//         </div>

//         <div className="grid lg:grid-cols-12 gap-6 sm:gap-8 md:gap-10">
          
//           {/* LEFT CARD */}
//           <div className="lg:col-span-5 space-y-6 sm:space-y-8">
//             <div
//               className="p-6 sm:p-8 md:p-10 lg:p-12 rounded-3xl border border-white/10 shadow-2xl h-full flex flex-col justify-between"
//               style={{ backgroundColor: COLORS.bgSecondary }}
//             >
//               <div className="space-y-8 sm:space-y-10 md:space-y-12">

//                 {/* Office */}
//                 <div className="flex gap-4 sm:gap-6 items-start">
//                   <div className="p-3 sm:p-4 rounded-2xl bg-white/5 border border-white/10">
//                     <FaMapMarkerAlt
//                       size={20}
//                       className="sm:w-6 sm:h-6"
//                       style={{ color: COLORS.gold }}
//                     />
//                   </div>

//                   <div>
//                     <h4 className="text-white text-base sm:text-lg md:text-xl font-bold mb-1 sm:mb-2">
//                       Office Chamber
//                     </h4>

//                     <p className="text-gray-400 text-sm sm:text-base md:text-lg leading-relaxed">
//                       Chamber No. 652, 6th Floor, Lawyers Block, <br />
//                       Saket Court Complex, New Delhi - 110017
//                     </p>
//                   </div>
//                 </div>

//                 {/* Contact */}
//                 <div className="flex gap-4 sm:gap-6 items-start">
//                   <div className="p-3 sm:p-4 rounded-2xl bg-white/5 border border-white/10">
//                     <FaPhoneAlt
//                       size={20}
//                       className="sm:w-6 sm:h-6"
//                       style={{ color: COLORS.gold }}
//                     />
//                   </div>

//                   <div>
//                     <h4 className="text-white text-base sm:text-lg md:text-xl font-bold mb-1 sm:mb-2">
//                       Direct Contact
//                     </h4>

//                     <p className="text-white text-lg sm:text-xl md:text-2xl font-bold mb-1">
//                       +9 1 9625975135
//                     </p>

//                     <p className="text-gray-400 text-sm sm:text-base md:text-lg">
//                       arunchaudhri1258@gmail.com
//                     </p>
//                   </div>
//                 </div>

//                 {/* WhatsApp */}
//                 <a
//                   href="https://wa.me/919625975135"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="flex items-center gap-3 sm:gap-4 p-3 sm:p-4 rounded-2xl border border-[#C6A75E]/30 bg-[#C6A75E]/5 hover:bg-[#C6A75E]/10 transition-all group"
//                 >
//                   <FaWhatsapp
//                     size={22}
//                     className="sm:w-7 sm:h-7"
//                     style={{ color: COLORS.gold }}
//                   />

//                   <span className="text-white font-bold text-sm sm:text-base md:text-lg group-hover:translate-x-1 transition-transform">
//                     Chat with an Expert on WhatsApp
//                   </span>
//                 </a>

//                 {/* Social */}
//                 <div className="flex flex-wrap gap-3 sm:gap-5 pt-2 sm:pt-4">
//                   {[FaFacebookF, FaLinkedinIn, FaInstagram, FaYoutube].map(
//                     (Icon, i) => (
//                       <button
//                         key={i}
//                         type="button"
//                         aria-label="Social Link"
//                         className="w-10 h-10 sm:w-12 sm:h-12 rounded-xl bg-white/5 border border-white/10 flex items-center justify-center text-white hover:bg-[#C6A75E] hover:text-[#0B1C2D] transition-all"
//                       >
//                         <Icon size={16} className="sm:w-[18px] sm:h-[18px]" />
//                       </button>
//                     )
//                   )}
//                 </div>

//               </div>
//             </div>
//           </div>

//           {/* RIGHT FORM */}
//           <div className="lg:col-span-7">
//             <form
//               onSubmit={handleSubmit}
//               className="bg-white/5 p-6 sm:p-8 md:p-10 lg:p-14 rounded-3xl border border-white/10 backdrop-blur-sm space-y-6 sm:space-y-8 md:space-y-10"
//             >
//               <h3 className="text-xl sm:text-2xl md:text-3xl text-white font-bold mb-4 sm:mb-6">
//                 Send a Message
//               </h3>

//               <div className="grid md:grid-cols-2 gap-4 sm:gap-6 md:gap-8">

//                 <div className="space-y-2 sm:space-y-3">
//                   <label className="text-gray-300 text-xs sm:text-sm font-bold uppercase tracking-wider">
//                     Full Name
//                   </label>
//                   <input
//                     type="text"
//                     name="name"
//                     required
//                     placeholder="Enter your name"
//                     value={formData.name}
//                     onChange={handleChange}
//                     className="w-full bg-[#13293D] border border-white/10 rounded-xl px-4 sm:px-6 py-3 sm:py-4 text-white text-sm sm:text-base md:text-lg"
//                   />
//                 </div>

//                 <div className="space-y-2 sm:space-y-3">
//                   <label className="text-gray-300 text-xs sm:text-sm font-bold uppercase tracking-wider">
//                     Email Address
//                   </label>
//                   <input
//                     type="email"
//                     name="email"
//                     required
//                     placeholder="Enter your email"
//                     value={formData.email}
//                     onChange={handleChange}
//                     className="w-full bg-[#13293D] border border-white/10 rounded-xl px-4 sm:px-6 py-3 sm:py-4 text-white text-sm sm:text-base md:text-lg"
//                   />
//                 </div>

//               </div>

//               <div className="space-y-2 sm:space-y-3">
//                 <label className="text-gray-300 text-xs sm:text-sm font-bold uppercase tracking-wider">
//                   Subject
//                 </label>
//                 <input
//                   type="text"
//                   name="subject"
//                   placeholder="What is this regarding?"
//                   value={formData.subject}
//                   onChange={handleChange}
//                   className="w-full bg-[#13293D] border border-white/10 rounded-xl px-4 sm:px-6 py-3 sm:py-4 text-white text-sm sm:text-base md:text-lg"
//                 />
//               </div>

//               <div className="space-y-2 sm:space-y-3">
//                 <label className="text-gray-300 text-xs sm:text-sm font-bold uppercase tracking-wider">
//                   Your Message
//                 </label>
//                 <textarea
//                   name="message"
//                   rows="4"
//                   required
//                   placeholder="Describe your legal matter..."
//                   value={formData.message}
//                   onChange={handleChange}
//                   className="w-full bg-[#13293D] border border-white/10 rounded-xl px-4 sm:px-6 py-3 sm:py-5 text-white text-sm sm:text-base md:text-lg resize-none"
//                 ></textarea>
//               </div>

//               <button
//                 type="submit"
//                 style={{
//                   backgroundColor: COLORS.gold,
//                   color: COLORS.bgPrimary,
//                 }}
//                 className="w-full py-3 sm:py-4 md:py-5 rounded-xl font-black uppercase tracking-[0.15em] sm:tracking-[0.2em] text-sm sm:text-base md:text-lg hover:scale-[1.01] active:scale-[0.98] transition-all shadow-xl shadow-[#C6A75E]/10"
//               >
//                 Submit Consultation Request
//               </button>
//             </form>
//           </div>

//         </div>
//       </div>
//     </section>
//   );
// };

// export default ContactForm;


// import React, { useState } from "react";
// import {
//   FaPhoneAlt,
//   FaMapMarkerAlt,
//   FaLinkedinIn,
//   FaInstagram,
//   FaFacebookF,
//   FaYoutube,
//   FaWhatsapp,
// } from "react-icons/fa";

// const ContactForm = () => {
//   const COLORS = {
//   bgPrimary: "#0A0A0A",   // Deep Black
//   bgSecondary: "#151515", // Slightly Lighter Black
//   gold: "#8B5E3C",        // Premium Brown (replacing gold)
//   textLight: "#EAEAEA",
// };

//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     subject: "",
//     message: "",
//   });

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({ ...formData, [name]: value });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     const { name, email, subject, message } = formData;

//     const whatsappMessage = `New Contact Form Submission:%0AName: ${name}%0AEmail: ${email}%0ASubject: ${subject}%0AMessage: ${message}`;
//     const adminNumber = "919625975135";

//     window.open(
//       `https://wa.me/${adminNumber}?text=${whatsappMessage}`,
//       "_blank",
//       "noopener noreferrer"
//     );

//     setFormData({ name: "", email: "", subject: "", message: "" });
//   };

//   return (
//     <section
//       style={{ backgroundColor: COLORS.bgPrimary }}
//       className="py-16 sm:py-20 md:py-24 px-4 sm:px-6 md:px-12 lg:px-20 relative"
//     >
//       <div className="max-w-7xl mx-auto">
        
//         {/* HEADER */}
//         <div className="mb-10 sm:mb-12 md:mb-16">
//           <div className="flex items-center gap-3 sm:gap-4 mb-3 sm:mb-4">
//             <div
//               className="h-[2px] w-10 sm:w-16"
//               style={{ backgroundColor: COLORS.gold }}
//             ></div>

//             <span
//               style={{ color: COLORS.gold }}
//               className="uppercase tracking-widest text-xs sm:text-sm font-bold"
//             >
//               Legal Support
//             </span>
//           </div>

//           <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-7xl text-white font-bold leading-tight">
//             Contact{" "}
//             <span className="text-white/40 font-light">
//               Adv. Shailendra Kumar Singh, Criminal Lawyer.
//             </span>
//           </h2>
//         </div>

//         <div className="grid lg:grid-cols-12 gap-6 sm:gap-8 md:gap-10">
          
//           {/* LEFT CARD */}
//           <div className="lg:col-span-5 space-y-6 sm:space-y-8">
//             <div
//               className="p-6 sm:p-8 md:p-10 lg:p-12 rounded-3xl border border-white/10 shadow-2xl h-full flex flex-col justify-between"
//               style={{ backgroundColor: COLORS.bgSecondary }}
//             >
//               <div className="space-y-8 sm:space-y-10 md:space-y-12">

//                 {/* Office */}
//                 <div className="flex gap-4 sm:gap-6 items-start">
//                   <div className="p-3 sm:p-4 rounded-2xl bg-white/5 border border-white/10">
//                     <FaMapMarkerAlt
//                       size={20}
//                       className="sm:w-6 sm:h-6"
//                       style={{ color: COLORS.gold }}
//                     />
//                   </div>

//                   <div>
//                     <h4 className="text-white text-base sm:text-lg md:text-xl font-bold mb-1 sm:mb-2">
//                       Office Chamber
//                     </h4>

//                     <p className="text-gray-400 text-sm sm:text-base md:text-lg leading-relaxed">
//                       Chamber No. 471, LAWYERS BLOCK,  <br />
//                       SAKET COURT, Sector 6, Complex, New Delhi, Delhi 110017
//                     </p>
//                   </div>
//                 </div>

//                 {/* Contact */}
//                 <div className="flex gap-4 sm:gap-6 items-start">
//                   <div className="p-3 sm:p-4 rounded-2xl bg-white/5 border border-white/10">
//                     <FaPhoneAlt
//                       size={20}
//                       className="sm:w-6 sm:h-6"
//                       style={{ color: COLORS.gold }}
//                     />
//                   </div>

//                   <div>
//                     <h4 className="text-white text-base sm:text-lg md:text-xl font-bold mb-1 sm:mb-2">
//                       Direct Contact
//                     </h4>

//                     <p className="text-white text-lg sm:text-xl md:text-2xl font-bold mb-1">
//                       +91 98181 04905
//                     </p>

//                     <p className="text-gray-400 text-sm sm:text-base md:text-lg">
//                       Shailendrakumarsingh9818@gmail.com.
//                     </p>
//                   </div>
//                 </div>

//                 {/* WhatsApp */}
//                 <a
//                   href="https://wa.me/919818104905"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="flex items-center gap-3 sm:gap-4 p-3 sm:p-4 rounded-2xl border border-[#C6A75E]/30 bg-[#C6A75E]/5 hover:bg-[#C6A75E]/10 transition-all group"
//                 >
//                   <FaWhatsapp
//                     size={22}
//                     className="sm:w-7 sm:h-7"
//                     style={{ color: COLORS.gold }}
//                   />

//                   <span className="text-white font-bold text-sm sm:text-base md:text-lg group-hover:translate-x-1 transition-transform">
//                     Chat with an Expert on WhatsApp
//                   </span>
//                 </a>

//                 {/* Social */}
//                 <div className="flex flex-wrap gap-3 sm:gap-5 pt-2 sm:pt-4">
//                   {[FaFacebookF, FaLinkedinIn, FaInstagram, FaYoutube].map(
//                     (Icon, i) => (
//                       <button
//                         key={i}
//                         type="button"
//                         aria-label="Social Link"
//                         className="w-10 h-10 sm:w-12 sm:h-12 rounded-xl bg-white/5 border border-white/10 flex items-center justify-center text-white hover:bg-[#C6A75E] hover:text-[#0B1C2D] transition-all"
//                       >
//                         <Icon size={16} className="sm:w-[18px] sm:h-[18px]" />
//                       </button>
//                     )
//                   )}
//                 </div>

//               </div>
//             </div>
//           </div>

//           {/* RIGHT FORM */}
//           <div className="lg:col-span-7">
//             <form
//               onSubmit={handleSubmit}
//               className="bg-white/5 p-6 sm:p-8 md:p-10 lg:p-14 rounded-3xl border border-white/10 backdrop-blur-sm space-y-6 sm:space-y-8 md:space-y-10"
//             >
//               <h3 className="text-xl sm:text-2xl md:text-3xl text-white font-bold mb-4 sm:mb-6">
//                 Send a Message
//               </h3>

//               <div className="grid md:grid-cols-2 gap-4 sm:gap-6 md:gap-8">

//                 <div className="space-y-2 sm:space-y-3">
//                   <label className="text-gray-300 text-xs sm:text-sm font-bold uppercase tracking-wider">
//                     Full Name
//                   </label>
//                   <input
//                     type="text"
//                     name="name"
//                     required
//                     placeholder="Enter your name"
//                     value={formData.name}
//                     onChange={handleChange}
//                     className="w-full bg-[#13293D] border border-white/10 rounded-xl px-4 sm:px-6 py-3 sm:py-4 text-white text-sm sm:text-base md:text-lg"
//                   />
//                 </div>

//                 <div className="space-y-2 sm:space-y-3">
//                   <label className="text-gray-300 text-xs sm:text-sm font-bold uppercase tracking-wider">
//                     Email Address
//                   </label>
//                   <input
//                     type="email"
//                     name="email"
//                     required
//                     placeholder="Enter your email"
//                     value={formData.email}
//                     onChange={handleChange}
//                     className="w-full bg-[#13293D] border border-white/10 rounded-xl px-4 sm:px-6 py-3 sm:py-4 text-white text-sm sm:text-base md:text-lg"
//                   />
//                 </div>

//               </div>

//               <div className="space-y-2 sm:space-y-3">
//                 <label className="text-gray-300 text-xs sm:text-sm font-bold uppercase tracking-wider">
//                   Subject
//                 </label>
//                 <input
//                   type="text"
//                   name="subject"
//                   placeholder="What is this regarding?"
//                   value={formData.subject}
//                   onChange={handleChange}
//                   className="w-full bg-[#13293D] border border-white/10 rounded-xl px-4 sm:px-6 py-3 sm:py-4 text-white text-sm sm:text-base md:text-lg"
//                 />
//               </div>

//               <div className="space-y-2 sm:space-y-3">
//                 <label className="text-gray-300 text-xs sm:text-sm font-bold uppercase tracking-wider">
//                   Your Message
//                 </label>
//                 <textarea
//                   name="message"
//                   rows="4"
//                   required
//                   placeholder="Describe your legal matter..."
//                   value={formData.message}
//                   onChange={handleChange}
//                   className="w-full bg-[#13293D] border border-white/10 rounded-xl px-4 sm:px-6 py-3 sm:py-5 text-white text-sm sm:text-base md:text-lg resize-none"
//                 ></textarea>
//               </div>

//               <button
//                 type="submit"
//                 style={{
//                   backgroundColor: COLORS.gold,
//                   color: COLORS.bgPrimary,
//                 }}
//                 className="w-full py-3 sm:py-4 md:py-5 rounded-xl font-black uppercase tracking-[0.15em] sm:tracking-[0.2em] text-sm sm:text-base md:text-lg hover:scale-[1.01] active:scale-[0.98] transition-all shadow-xl shadow-[#C6A75E]/10"
//               >
//                 Submit Consultation Request
//               </button>
//             </form>
//           </div>

//         </div>
//       </div>
//     </section>
//   );
// };

// export default ContactForm;

import React, { useState } from "react";
import {
  FaPhoneAlt,
  FaMapMarkerAlt,
  FaLinkedinIn,
  FaInstagram,
  FaFacebookF,
  FaYoutube,
  FaWhatsapp,
} from "react-icons/fa";

const ContactForm = () => {
  const COLORS = {
    bgPrimary: "#0A0A0A",
    bgSecondary: "#151515",
    gold: "#8B5E3C",
    textLight: "#EAEAEA",
  };

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { name, email, subject, message } = formData;

    const whatsappMessage = `New Contact Form Submission:%0AName: ${name}%0AEmail: ${email}%0ASubject: ${subject}%0AMessage: ${message}`;
    const adminNumber = "919818104905";

    window.open(
      `https://wa.me/${adminNumber}?text=${whatsappMessage}`,
      "_blank"
    );

    setFormData({ name: "", email: "", subject: "", message: "" });
  };

  return (
    <section
      style={{ backgroundColor: COLORS.bgPrimary }}
      className="py-12 sm:py-16 md:py-20 px-4 sm:px-6 md:px-10 lg:px-20"
    >
      <div className="max-w-7xl mx-auto">
        
        {/* HEADER */}
        <div className="mb-10 md:mb-14">
          <div className="flex items-center gap-3 mb-3">
            <div
              className="h-[2px] w-10 sm:w-14"
              style={{ backgroundColor: COLORS.gold }}
            ></div>

            <span
              style={{ color: COLORS.gold }}
              className="uppercase tracking-widest text-xs sm:text-sm font-bold"
            >
              Legal Support
            </span>
          </div>

          <h2 className="text-xl sm:text-3xl md:text-5xl lg:text-6xl xl:text-6xl text-white font-bold leading-tight">
            Contact{" "}
            <span className="text-white/40 font-light block sm:inline">
              SKSLAWGROUPS & <b className="text-bold text-white">ASSOCIATES</b>
            </span>
          </h2>
        </div>

        {/* GRID */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 md:gap-10">
          
          {/* LEFT */}
          <div className="lg:col-span-5">
            <div
              className="p-5 sm:p-6 md:p-8 lg:p-10 rounded-2xl sm:rounded-3xl border border-white/10 shadow-xl h-full"
              style={{ backgroundColor: COLORS.bgSecondary }}
            >
              <div className="space-y-6 sm:space-y-8">

                {/* Office */}
                <div className="flex gap-3 sm:gap-5">
                  <div className="p-3 rounded-xl bg-white/5 border border-white/10">
                    <FaMapMarkerAlt style={{ color: COLORS.gold }} />
                  </div>

                  <div>
                    <h4 className="text-white font-semibold text-sm sm:text-lg">
                      Office Chamber
                    </h4>
                    <p className="text-gray-400 text-xs sm:text-sm md:text-base leading-relaxed">
                      Chamber No. 471, LAWYERS BLOCK, SAKET COURT,
                      New Delhi 110017
                    </p>
                  </div>
                </div>

                {/* Contact */}
                <div className="flex gap-3 sm:gap-5">
                  <div className="p-3 rounded-xl bg-white/5 border border-white/10">
                    <FaPhoneAlt style={{ color: COLORS.gold }} />
                  </div>

                  <div>
                    <h4 className="text-white font-semibold text-sm sm:text-lg">
                      Direct Contact
                    </h4>
                    <p className="text-white font-bold text-base sm:text-lg">
                      +91 98181 04905
                    </p>
                    <p className="text-gray-400 text-xs sm:text-sm">
                      skslawgroups@gmail.com
                    </p>
                  </div>
                </div>

                {/* WhatsApp */}
                <a
                  href="https://wa.me/919818104905"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 p-3 rounded-xl border border-[#C6A75E]/30 bg-[#C6A75E]/5 hover:bg-[#C6A75E]/10 transition"
                >
                  <FaWhatsapp style={{ color: COLORS.gold }} />
                  <span className="text-white text-sm sm:text-base font-medium">
                    Chat on WhatsApp
                  </span>
                </a>

                {/* Social */}
                <div className="flex gap-3 sm:gap-4 flex-wrap">
  {[
    {
      icon: FaFacebookF,
      link: "https://www.facebook.com/people/Adv-Shailendra-Kumar-Singh/61577653947345/",
    },
    // {
    //   icon: FaLinkedinIn,
    //   link: "https://linkedin.com/in/yourprofile",
    // },
    {
      icon: FaInstagram,
      link: "https://www.instagram.com/shailendrakumarsingh9818/",
    },
    // {
    //   icon: FaYoutube,
    //   link: "https://youtube.com/@yourchannel",
    // },
  ].map((item, i) => {
    const Icon = item.icon;
    return (
      <a
        key={i}
        href={item.link}
        target="_blank"
        rel="noopener noreferrer"
        className="w-9 h-9 sm:w-11 sm:h-11 rounded-lg bg-white/5 border border-white/10 flex items-center justify-center text-white hover:bg-[#C6A75E] transition"
      >
        <Icon size={14} />
      </a>
    );
  })}
</div>

              </div>
            </div>
          </div>

          {/* RIGHT FORM */}
          <div className="lg:col-span-7">
            <form
              onSubmit={handleSubmit}
              className="bg-white/5 p-5 sm:p-6 md:p-8 lg:p-10 rounded-2xl sm:rounded-3xl border border-white/10 space-y-6"
            >
              <h3 className="text-lg sm:text-xl md:text-2xl text-white font-bold">
                Send a Message
              </h3>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <input
                  type="text"
                  name="name"
                  required
                  placeholder="Full Name"
                  value={formData.name}
                  onChange={handleChange}
                  className="w-full bg-[#13293D] rounded-lg px-4 py-3 text-white text-sm"
                />

                <input
                  type="email"
                  name="email"
                  required
                  placeholder="Email Address"
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full bg-[#13293D] rounded-lg px-4 py-3 text-white text-sm"
                />
              </div>

              <input
                type="text"
                name="subject"
                placeholder="Subject"
                value={formData.subject}
                onChange={handleChange}
                className="w-full bg-[#13293D] rounded-lg px-4 py-3 text-white text-sm"
              />

              <textarea
                name="message"
                rows="4"
                required
                placeholder="Your Message"
                value={formData.message}
                onChange={handleChange}
                className="w-full bg-[#13293D] rounded-lg px-4 py-3 text-white text-sm resize-none"
              ></textarea>

              <button
                type="submit"
                style={{
                  backgroundColor: COLORS.gold,
                  color: COLORS.bgPrimary,
                }}
                className="w-full py-3 rounded-lg font-bold text-sm sm:text-base hover:scale-[1.02] transition"
              >
                Submit Request
              </button>
            </form>
          </div>

        </div>
      </div>
    </section>
  );
};

export default ContactForm;